exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-button--default[data-v-81ba750e]{color:#fff!important}", ""]);

// exports
